export default {
    // index.vue
    welcome_login: '欢迎登录',
    meeting_backend: '会议后台管理',

    // forum-config/info.vue
    forum_config: {
        enter_forum_id: '请输入论坛ID',
        forum_name: '论坛名称',
        enter_forum_name: '请输入论坛名称',
        forum_name_en: '论坛英文名称',
        enter_forum_name_en: '请输入论坛英文名称',
        start_time: '开展时间',
        select_start_time: '请选择开展时间',
        region: '所属地区',
        address: '详细地址',
        enter_address: '请输入详细地址',
        cover_image: '封面图',
        upload_cover: '请上传封面图',
        upload_image: '上传图片',
        intro: '简介',
        enter_intro: '请输入简介',
        submit: '立即提交',
        operation_success: '操作成功',
        only_image: '您只能上传图像文件'
    },

    // goods-module/goods.vue
    goods: {
        enter_ticket_name: '请输入门票名称',
        select_ticket_status: '请选择门票状态',
        select_ticket_type: '请选择门票类型',
        search: '搜索',
        reset: '重置',
        unlimited: '无限制',
        put_on: '上架',
        put_off: '下架',
        name: '门票名称',
        status: '门票状态',
        goods_number: '门票编号',
        type_name: '门票类型',
        sales_volume: '库存',
        sale_num: '销量',
        action: '操作',
        inventory: '库存',
        sales_period: '销售时段'
    }
};
